import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AuthContext, FULL_ACCESS_ROLES } from '../utils/AuthContext';

const ROUTE_MODULE_MAP = {
    '/sample-registration': 'sample_registration',
    '/sample-registration-list': 'sample_registration',
    '/sample-preparation': 'sample_preparation',
    '/sample-preparation-view': 'sample_preparation',
    '/sample-preparation-report': 'sample_preparation',
    '/library-preparation': 'library_preparation',
    '/library-preparation-view': 'library_preparation',
    '/sequencing': 'sequencing',
    '/sequencing-view': 'sequencing',
    '/bio-informatics-data-analysis': 'bioinformatics',
    '/bioinformatics-view': 'bioinformatics',
    '/customer-details-list': 'customer_details',
    '/customerdetails': 'customer_details',
    '/customer-projects': 'customer_details',
    '/customer-project': 'customer_details',
    '/dashboard': 'dashboard',
    '/projects': 'projects',
    '/project': 'projects',
    '/payment': 'payment',
};

const resolveModule = (pathname) => {
    const p = pathname.toLowerCase();
    if (ROUTE_MODULE_MAP[p]) return ROUTE_MODULE_MAP[p];
    let best = null;
    for (const key of Object.keys(ROUTE_MODULE_MAP)) {
        if (p.startsWith(key) && (!best || key.length > best.length)) best = key;
    }
    return best ? ROUTE_MODULE_MAP[best] : null;
};

// Read permissions from localStorage as a fallback when context state is empty
// (guards against the login → redirect re-mount race).
const readStoredPermissions = () => {
    try { return JSON.parse(localStorage.getItem('permissions') || '{}'); }
    catch { return {}; }
};

const ProtectedRoute = ({ adminOnly = false }) => {
    const { user, permissions } = useContext(AuthContext);
    const location = useLocation();

    if (!user) return <Navigate to="/" replace />;

    const isAdmin = user.role === 'Super admin' || user.role === 'Admin';
    if (isAdmin) return <Outlet />;

    if (adminOnly) return <Navigate to="/unauthorized" replace />;

    const moduleKey = resolveModule(location.pathname);
    if (!moduleKey) return <Navigate to="/unauthorized" replace />;

    // context first; if empty (race / refresh), fall back to localStorage
    const ctxPerms = permissions && Object.keys(permissions).length ? permissions : readStoredPermissions();
    const allowed = !!(ctxPerms[moduleKey] && ctxPerms[moduleKey].view);

    return allowed ? <Outlet /> : <Navigate to="/unauthorized" replace />;
};

export default ProtectedRoute;